import { z } from 'zod';
/**
 * Watch alerts (docs/watch-alerts.md): the TV computer's web page reports the
 * hold state of a call on another provider's videophone, and the server
 * relays it to the same user's other devices, which vibrate a PineTime watch.
 * Metadata only: no picture, no call content.
 */
/** off_hold vibrates the watch; on_hold and screen_off only report state. */
export const tvAlertKindSchema = z.enum(['off_hold', 'on_hold', 'screen_off']);
/** Inbound WebSocket `tv_alert` data, sent by a signed-in client page. */
export const tvAlertPayloadSchema = z.object({
    eventId: z.string().uuid(),
    kind: tvAlertKindSchema,
    provider: z.string().trim().min(1).max(40).regex(/^[\p{L}\p{N} .,'&()+-]+$/u).optional(),
    at: z.string().datetime({ offset: true }).optional()
}).strict();
/** Outbound `watch_alert` data, to the user's other devices (WebSocket and data push). */
export const watchAlertPayloadSchema = z.object({
    eventId: z.string().uuid(),
    kind: tvAlertKindSchema,
    source: z.literal('tv'),
    provider: z.string().min(1).max(40).optional(),
    at: z.string().datetime({ offset: true })
}).strict();
